import { useEffect } from "react";
import { SchemaData, UseGetItemProps } from "./types";
import { ApiCMSRequest } from "data/ApiCMS";
import schemaJson from "../schema/SchemaJson.json";
import UISchemaJson from "../schema/UISchema.json";
import { GET_ITEM_QUERY, GetItemGql } from "../queries/getItem";
import { useNavigate } from "react-router-dom";
import { removeNullValues } from "utils/removeNullValues";

const useGetItem = ({ setState, setTemplate, queryParam }: UseGetItemProps<SchemaData>) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!!queryParam) {
      setState((props) => ({ ...props, messageError: undefined, criticalError: undefined }));
      ApiCMSRequest<GetItemGql>({
        query: GET_ITEM_QUERY,
        variables: { slug: queryParam },
      })
        .then((response) => {
          if (!response?.data?.data?.Page) {
            throw new Error("Não encontrado", {
              cause: { response: response?.data || response },
            });
          } else if (!response?.data?.data?.Page.dynamicPage) {
            setTimeout(() => navigate("/uniftec/paginas-dinamicas"), 2000);
            throw new Error("Essa não é uma Página Dinamica", {
              cause: { response: response?.data || response },
            });
          }

          setTemplate({
            schemaJson: schemaJson,
            UISchema: UISchemaJson,
          });

          const { contentJSON, ...details } = response.data.data?.Page;

          setState({
            data: {
              details: removeNullValues(details),
              dynamicPageContent: removeNullValues({
                contentHtml: contentJSON,
              }),
            },
          });
        })
        .catch((error) => {
          console.log({ error });

          setState((prev) => ({
            ...prev,
            criticalError: error?.response?.data?.errors?.[0] || error,
          }));
        });
    }
  }, [queryParam]);
};

export default useGetItem;
